<div class="container" [ngStyle]="{left: (-current_frame*100) + '%'}">
	<div class="frame" *ngFor="let testimonial of testimonials; let i = index" [ngStyle]="{left: i+'00%' }" [ngClass]="{current: i == current_frame}">
		<div class="content">
			<p>
				<q [innerHtml]="testimonial.quote"></q>
				<b> - {{ testimonial.author }}</b>
			</p>

			<p class="stars">
				<img [src]="'assets/iconStar.svg'" alt="★" *ngFor="let i of ' '.repeat(testimonial.stars).split('')">
			</p>
		</div>
	</div>
</div>
<p class="prev" (click)="change(current_frame - 1)"></p>
<p class="next" (click)="change(current_frame + 1)"></p>
